import { ILogInBody } from '../../types';
import instance from '.';

export const postSignIn = async (body: ILogInBody) => {
  const { data } = await instance.post('admin-sign-on', body);

  return data;
};
